module.exports = "<span>\n    <strong>{{label}}</strong>\n</span>\n<span style=\"font-size: 13px\">\n        {{result | json}}\n</span>";


//////////////////
// WEBPACK FOOTER
// ./resources/assets/javascript/templates/buildings/building-composition.html
// module id = ./resources/assets/javascript/templates/buildings/building-composition.html
// module chunks = 54